import { motion, AnimatePresence } from 'framer-motion';

interface BulkActionBarProps {
  selectedCount: number;
  entityName?: string;
  onClearSelection: () => void;
  onDelete: () => void;
  isDeleting?: boolean;
}

export function BulkActionBar({
  selectedCount,
  entityName = 'items',
  onClearSelection,
  onDelete,
  isDeleting = false,
}: BulkActionBarProps) {
  return (
    <AnimatePresence>
      {selectedCount > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.95 }}
          transition={{ duration: 0.18, ease: 'easeOut' }}
          className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 bg-gray-900/95 text-white px-5 py-2.5 rounded-2xl shadow-2xl backdrop-blur-md border border-gray-700/60 flex items-center gap-4 select-none"
        >
          {/* Badge & Label */}
          <div className="flex items-center gap-2 text-sm font-medium">
            <span className="inline-flex items-center justify-center min-w-6 h-6 px-1.5 rounded-full bg-brand-600 text-xs font-bold text-white shadow-xs">
              {selectedCount}
            </span>
            <span className="text-gray-200">
              {entityName} selected
            </span>
          </div>

          <div className="h-4 w-px bg-gray-700" />

          {/* Deselect Shortcut */}
          <button
            type="button"
            onClick={onClearSelection}
            disabled={isDeleting}
            className="text-xs text-gray-400 hover:text-white transition-colors cursor-pointer font-medium disabled:opacity-50"
          >
            Deselect all
          </button>

          {/* Delete Action Button */}
          <button
            type="button"
            onClick={onDelete}
            disabled={isDeleting}
            className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-xl text-xs font-semibold bg-red-600 hover:bg-red-700 text-white transition-all cursor-pointer shadow-sm hover:shadow active:scale-98 disabled:opacity-50"
          >
            {isDeleting ? (
              <span className="inline-block animate-spin rounded-full h-3.5 w-3.5 border-2 border-white border-t-transparent mr-1" />
            ) : (
              <svg
                className="w-3.5 h-3.5 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
            <span>Delete ({selectedCount})</span>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

